import { render, staticRenderFns } from "./situacionesLaborales.vue?vue&type=template&id=6ed402b8"
import script from "./situacionesLaborales.vue?vue&type=script&lang=js"
export * from "./situacionesLaborales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports